import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'web-drag-handle',
    templateUrl: './drag-handle.component.html',
    styleUrls: ['./drag-handle.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DragHandleComponent {}
